import { useId } from 'react';

var useEmptyId = function useEmptyId() {
  return '';
};

var useThemeKey = typeof useId === 'undefined' ? useEmptyId : useId;
export default useThemeKey;